import { http } from '../http';
import { convertToApcProductId, convertToApcSkuId } from './utils';
export const getApcCta = (apcCtaUrl) => {
  return http.get(apcCtaUrl);
};
export const getAvailabilityInfo = (availabilityUrl) => {
  return http.get(availabilityUrl, {}, { credentials: 'include' });
};
export const postApcAddToCart = (apcAddToCartUrl, params) => {
  return http.post(apcAddToCartUrl, params, { credentials: 'include' });
};
export const removeFromFavoritesRequest = (url, params) => {
  return http.post(url, params, { credentials: 'include' });
};
export const addToFavoritesRequest = (url, { giftlistId, productId }) => {
  return http.post(url, {
    giftlistId,
    quantity: 1,
    productId: convertToApcProductId(productId),
    catalogRefIds: [convertToApcSkuId(productId)],
  }, { credentials: 'include' });
};
